import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import transition from '../../utils/transition.js';
import { jsx } from '@emotion/react';
import { TouchTarget } from '../TouchTarget/TouchTarget.js';

const baseStyles = () => ({
  fontFamily: "default",
  position: "relative",
  background: "none",
  color: "foreground.action.strong",
  border: "none",
  paddingBlockStart: 0,
  paddingBlockEnd: 0,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  cursor: "pointer",
  transition: _ref => {
    let {
      transitions
    } = _ref;
    return transition(transitions.default, "color", "box-shadow");
  },
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none"
  },
  "&:hover": {
    color: "foreground.action.strong.hover"
  },
  "&:active": {
    color: "foreground.action.strong.active"
  },
  "&:focus-visible": {
    outline: "none",
    boxShadow: "focus"
  }
});
const variantStyles = {
  icon: {
    borderRadius: "sm",
    lineHeight: 0
  },
  link: {
    textDecorationLine: "underline",
    textDecorationThickness: "0.0625rem",
    textDecorationStyle: "dotted",
    textDecorationColor: "foreground.action.strong",
    textDecorationSkipInk: "none",
    textUnderlineOffset: "0.25em",
    textUnderlinePosition: "auto",
    borderBottom: "none",
    cursor: "pointer",
    fontSize: "inherit",
    "&:hover": {
      textDecorationColor: "foreground.action.strong.hover"
    },
    "&:active": {
      textDecorationColor: "foreground.action.strong.active"
    }
  }
};
const ThemedButton = /*#__PURE__*/themed("button", process.env.NODE_ENV === "production" ? {
  styleProps: ["variant"],
  shouldForwardProp: prop => prop !== "variant",
  target: "e153n8480"
} : {
  styleProps: ["variant"],
  shouldForwardProp: prop => prop !== "variant",
  target: "e153n8480",
  label: "ThemedButton"
})(baseStyles, _ref2 => {
  let {
    variant = "icon"
  } = _ref2;
  return variantStyles[variant];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkluZm9CdXR0b24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVFcUIiLCJmaWxlIjoiSW5mb0J1dHRvbi50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50UHJvcHNXaXRoUmVmLCBmb3J3YXJkUmVmIH0gZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgeyB0aGVtZWQsIFN5c3RlbVN0eWxlT2JqZWN0LCBTdHlsZVByb3BzIH0gZnJvbSBcIkBpbmRlZWQvaWZsLWNzc1wiO1xuaW1wb3J0IHsgVG91Y2hUYXJnZXQgfSBmcm9tIFwiLi4vVG91Y2hUYXJnZXRcIjtcbmltcG9ydCB0eXBlIHsgSW5kZWVkVGhlbWUgfSBmcm9tIFwiQGluZGVlZC9pZmwtdGhlbWVzXCI7XG5pbXBvcnQgdHJhbnNpdGlvbiBmcm9tIFwiLi4vLi4vdXRpbHMvdHJhbnNpdGlvblwiO1xuXG5jb25zdCBiYXNlU3R5bGVzID0gKCk6IFN5c3RlbVN0eWxlT2JqZWN0ID0+ICh7XG4gIGZvbnRGYW1pbHk6IFwiZGVmYXVsdFwiLFxuICBwb3NpdGlvbjogXCJyZWxhdGl2ZVwiLFxuICBiYWNrZ3JvdW5kOiBcIm5vbmVcIixcbiAgY29sb3I6IFwiZm9yZWdyb3VuZC5hY3Rpb24uc3Ryb25nXCIsXG4gIGJvcmRlcjogXCJub25lXCIsXG4gIHBhZGRpbmdCbG9ja1N0YXJ0OiAwLFxuICBwYWRkaW5nQmxvY2tFbmQ6IDAsXG4gIHBhZGRpbmdJbmxpbmVTdGFydDogMCxcbiAgcGFkZGluZ0lubGluZUVuZDogMCxcbiAgY3Vyc29yOiBcInBvaW50ZXJcIixcbiAgdHJhbnNpdGlvbjogKHsgdHJhbnNpdGlvbnMgfTogSW5kZWVkVGhlbWUpID0+XG4gICAgdHJhbnNpdGlvbih0cmFuc2l0aW9ucy5kZWZhdWx0LCBcImNvbG9yXCIsIFwiYm94LXNoYWRvd1wiKSxcbiAgXCJAbWVkaWEgKHByZWZlcnMtcmVkdWNlZC1tb3Rpb246IHJlZHVjZSlcIjoge1xuICAgIHRyYW5zaXRpb246IFwibm9uZVwiXG4gIH0sXG4gIFwiJjpob3ZlclwiOiB7XG4gICAgY29sb3I6IFwiZm9yZWdyb3VuZC5hY3Rpb24uc3Ryb25nLmhvdmVyXCJcbiAgfSxcbiAgXCImOmFjdGl2ZVwiOiB7XG4gICAgY29sb3I6IFwiZm9yZWdyb3VuZC5hY3Rpb24uc3Ryb25nLmFjdGl2ZVwiXG4gIH0sXG4gIFwiJjpmb2N1cy12aXNpYmxlXCI6IHtcbiAgICBvdXRsaW5lOiBcIm5vbmVcIixcbiAgICBib3hTaGFkb3c6IFwiZm9jdXNcIlxuICB9XG59KTtcblxuY29uc3QgdmFyaWFudFN0eWxlczogUmVjb3JkPEluZm9CdXR0b25WYXJpYW50LCBTeXN0ZW1TdHlsZU9iamVjdD4gPSB7XG4gIGljb246IHtcbiAgICBib3JkZXJSYWRpdXM6IFwic21cIixcbiAgICBsaW5lSGVpZ2h0OiAwXG4gIH0sXG4gIGxpbms6IHtcbiAgICB0ZXh0RGVjb3JhdGlvbkxpbmU6IFwidW5kZXJsaW5lXCIsXG4gICAgdGV4dERlY29yYXRpb25UaGlja25lc3M6IFwiMC4wNjI1cmVtXCIsXG4gICAgdGV4dERlY29yYXRpb25TdHlsZTogXCJkb3R0ZWRcIixcbiAgICB0ZXh0RGVjb3JhdGlvbkNvbG9yOiBcImZvcmVncm91bmQuYWN0aW9uLnN0cm9uZ1wiLFxuICAgIHRleHREZWNvcmF0aW9uU2tpcEluazogXCJub25lXCIsXG4gICAgdGV4dFVuZGVybGluZU9mZnNldDogXCIwLjI1ZW1cIixcbiAgICB0ZXh0VW5kZXJsaW5lUG9zaXRpb246IFwiYXV0b1wiLFxuICAgIGJvcmRlckJvdHRvbTogXCJub25lXCIsXG4gICAgY3Vyc29yOiBcInBvaW50ZXJcIixcbiAgICBmb250U2l6ZTogXCJpbmhlcml0XCIsXG4gICAgXCImOmhvdmVyXCI6IHtcbiAgICAgIHRleHREZWNvcmF0aW9uQ29sb3I6IFwiZm9yZWdyb3VuZC5hY3Rpb24uc3Ryb25nLmhvdmVyXCJcbiAgICB9LFxuICAgIFwiJjphY3RpdmVcIjoge1xuICAgICAgdGV4dERlY29yYXRpb25Db2xvcjogXCJmb3JlZ3JvdW5kLmFjdGlvbi5zdHJvbmcuYWN0aXZlXCJcbiAgICB9XG4gIH1cbn07XG5cbmV4cG9ydCB0eXBlIEluZm9CdXR0b25WYXJpYW50ID0gXCJpY29uXCIgfCBcImxpbmtcIjtcblxuZXhwb3J0IGludGVyZmFjZSBJbmZvQnV0dG9uUHJvcHNcbiAgZXh0ZW5kcyBTdHlsZVByb3BzLFxuICAgIENvbXBvbmVudFByb3BzV2l0aFJlZjxcImJ1dHRvblwiPiB7XG4gIC8qKlxuICAgKiBTZXRzIHRoZSBzdHlsZSB2YXJpYW50IG9mIFwiaWNvblwiIG9yIFwibGlua1wiLlxuICAgKiBAZGVmYXVsdCBcImljb25cIlxuICAgKi9cbiAgdmFyaWFudD86IEluZm9CdXR0b25WYXJpYW50O1xufVxuXG5jb25zdCBUaGVtZWRCdXR0b24gPSB0aGVtZWQoXCJidXR0b25cIiwge1xuICBzdHlsZVByb3BzOiBbXCJ2YXJpYW50XCJdLFxuICBzaG91bGRGb3J3YXJkUHJvcDogcHJvcCA9PiBwcm9wICE9PSBcInZhcmlhbnRcIlxufSkoXG4gIGJhc2VTdHlsZXMsXG4gICh7IHZhcmlhbnQgPSBcImljb25cIiB9OiBJbmZvQnV0dG9uUHJvcHMpID0+IHZhcmlhbnRTdHlsZXNbdmFyaWFudF1cbik7XG5cbmNvbnN0IFRoZW1lZEluZm9CdXR0b24gPSBUb3VjaFRhcmdldC53aXRoQ29tcG9uZW50KFRoZW1lZEJ1dHRvbik7XG5cbmV4cG9ydCBjb25zdCBJbmZvQnV0dG9uID0gZm9yd2FyZFJlZjxIVE1MQnV0dG9uRWxlbWVudCwgSW5mb0J1dHRvblByb3BzPihcbiAgKHsgdmFyaWFudCA9IFwiaWNvblwiLCBhcywgLi4ucHJvcHMgfSwgZm9yd2FyZGVkUmVmKSA9PiB7XG4gICAgY29uc3QgY29tcG9uZW50ID0gKFxuICAgICAgPFRoZW1lZEluZm9CdXR0b25cbiAgICAgICAgYXM9e2FzfVxuICAgICAgICByZWY9e2ZvcndhcmRlZFJlZn1cbiAgICAgICAgdmFyaWFudD17dmFyaWFudH1cbiAgICAgICAgey4uLnByb3BzfVxuICAgICAgLz5cbiAgICApO1xuXG4gICAgcmV0dXJuIGNvbXBvbmVudDtcbiAgfVxuKTtcblxuZXhwb3J0IGNvbnN0IElORk9fQlVUVE9OX1ZBUklBTlRTID0gW1wiaWNvblwiLCBcImxpbmtcIl0gYXMgSW5mb0J1dHRvblZhcmlhbnRbXTtcbiJdfQ== */");
const ThemedInfoButton = TouchTarget.withComponent(ThemedButton, process.env.NODE_ENV === "production" ? {
  target: "e153n8481"
} : {
  target: "e153n8481",
  label: "ThemedInfoButton"
});
const InfoButton = /*#__PURE__*/forwardRef((_ref3, forwardedRef) => {
  let {
    variant = "icon",
    as,
    ...props
  } = _ref3;
  const component = jsx(ThemedInfoButton, _extends({
    as: as,
    ref: forwardedRef,
    variant: variant
  }, props));
  return component;
});
const INFO_BUTTON_VARIANTS = ["icon", "link"];

export { INFO_BUTTON_VARIANTS, InfoButton };
